/**
 * Format a DATE / date-only instant for display as the same civil day everywhere
 * (avoids "previous day" when the value is stored as UTC midnight).
 */
export function formatDateOnlyForDisplay(value: unknown): string {
  if (value == null || value === '') return ''
  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}/.test(value)) {
    const ymd = value.slice(0, 10)
    const d = new Date(`${ymd}T00:00:00.000Z`)
    if (!isNaN(d.getTime())) {
      return new Intl.DateTimeFormat(undefined, {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        timeZone: 'UTC'
      }).format(d)
    }
  }
  const d = new Date(value as string)
  if (isNaN(d.getTime())) return ''
  return new Intl.DateTimeFormat(undefined, {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    timeZone: 'UTC'
  }).format(d)
}
